// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeProfileGetBody = {};

export type typeProfileGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    profile?: {
      accountId: string;
      username: string;
      displayName: string;
      firstName?: string | null;
      lastName?: string | null;
      birthday?: string | null;
      phone?: string | null;
      photoUrl?: string | null;
      timezone: string;
      isDiscoverable: boolean;
      isPoolListVisible: boolean;
      followedSportIds: string[];
      followedLeagueIds: string[];
      favoriteTeamIds: string[];
      onboardingStep:
        | "username"
        | "details"
        | "signInMethods"
        | "photo"
        | "sports"
        | "leagues"
        | "done";
      isOnboardingComplete: boolean;
      usernameChangedAt?: string | null;
      usernameChangeCount: number;
      createdAt: string;
      usernameChangeAvailableAt?: string | null;
    } | null;
  };
};

export type typeProfileGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeProfileGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeProfileGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaProfileGetBody = { type: "object", properties: {} } as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createProfileGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaProfileGetBody);
  }

  return async function postProfileGet(
    payload: typeProfileGetBody,
  ): Promise<typeProfileGetOutput200 | typeProfileGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postProfileGet" failed before calling the network. #8d84378b3677`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#8d84378b3677" },
        },
        data: null,
      } as typeProfileGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/profile/get`,
      httpMethod: "POST",
      options,
    })) as typeProfileGetOutput200 | typeProfileGetOutput400;
  };
}
